import ShakhsSalesBimehNamehDetailSliceType from './ShakhsSalesBimehNamehDetailSliceType';

const ShakhsSalesBimehNamehDetailInitialState: ShakhsSalesBimehNamehDetailSliceType = {
  loading: false,
  data: null,
};

export default ShakhsSalesBimehNamehDetailInitialState;
